import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

interface MessageContextType {
  unreadCount: number;
  refreshUnreadCount: () => Promise<void>;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    if (!isAuthenticated) {
      setUnreadCount(0);
      return;
    }
    try {
      const response = await api.get('/messages/unread-count');
      setUnreadCount(response.data.count ?? 0);
    } catch (error) {
      // still keep previous count
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchUnread();
    if (!isAuthenticated) {
      return;
    }
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, [isAuthenticated, fetchUnread]);

  return (
    <MessageContext.Provider value={{ unreadCount, refreshUnreadCount: fetchUnread }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageContext = () => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    throw new Error('useMessageContext muss innerhalb eines MessageProvider verwendet werden');
  }
  return ctx;
};


